// SHRINK HEADER ON SCROLL
tetloose.headerShrink = function () {
    var $headerShrinkScrollAmount = $window.scrollTop(),
        $headerShrinkScrollOffest = $mastHead.outerHeight() / 2;

    $window.on('scroll', function() {
        $headerShrinkScrollAmount = $window.scrollTop();
        if ($headerShrinkScrollAmount > $headerShrinkScrollOffest) {
            $mastHead.addClass('is-scrolling');
            return false;
        }
        $mastHead.removeClass('is-scrolling');
    });
};
